/**
 * "Este relatório não pode existir ainda, e este é o motivo MEDIDO."
 *
 * Usado por Clientes (bloqueado na fonte, §7.4) e pelas abas de Estoque e
 * Movimentação, que dependem de um `Movimento` que não existe em nenhum dos
 * dois bancos.
 *
 * O que faz este painel valer alguma coisa é o bloco de diagnóstico: os números
 * vêm do banco, contados na hora ("29 clientes, 0 com saldo, 1 linha de banco
 * guarda todos"). É a diferença entre uma tela que DIZ que falta dado e uma que
 * PROVA que falta — e é o que faz a tela se corrigir sozinha no dia em que o
 * dado chegar.
 *
 * O que este painel nunca faz: preencher com zero. Zero mente.
 */
import React from "react";
import * as AlfredoStyles from "../../styles/components/reports/RelatorioComum";
import type { EstadoBloqueadoDados } from "../../comum/relatorios/tipos";

interface Props {
  dados?: EstadoBloqueadoDados;
}

const EstadoBloqueado: React.FC<Props> = ({ dados }) => {
  if (!dados) return null;

  return (
    <AlfredoStyles.PainelBloqueado>
      <AlfredoStyles.TituloBloqueado>
        {dados.titulo}
      </AlfredoStyles.TituloBloqueado>

      <AlfredoStyles.MotivoBloqueado>
        {dados.motivo}
      </AlfredoStyles.MotivoBloqueado>

      {dados.oQueFalta.length > 0 && (
        <>
          <AlfredoStyles.SubtituloBloqueado>
            O que falta para esta tela existir
          </AlfredoStyles.SubtituloBloqueado>
          <AlfredoStyles.ListaDoQueFalta>
            {dados.oQueFalta.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </AlfredoStyles.ListaDoQueFalta>
        </>
      )}

      {dados.diagnostico.length > 0 && (
        <>
          <AlfredoStyles.SubtituloBloqueado>
            Medido no banco agora
          </AlfredoStyles.SubtituloBloqueado>
          <AlfredoStyles.Diagnostico>
            {dados.diagnostico.map((medida) => (
              <AlfredoStyles.Medida key={medida.rotulo}>
                <AlfredoStyles.ValorDaMedida>
                  {medida.valor}
                </AlfredoStyles.ValorDaMedida>
                <AlfredoStyles.RotuloDaMedida>
                  {medida.rotulo}
                </AlfredoStyles.RotuloDaMedida>
              </AlfredoStyles.Medida>
            ))}
          </AlfredoStyles.Diagnostico>
        </>
      )}
    </AlfredoStyles.PainelBloqueado>
  );
};

export default EstadoBloqueado;
